import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { CropDto } from '../dto/CropDto';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiCropImage = async (
  section: string,
  route: string,
  page: string,
  dto?: CropDto
) => {
  const params: IApiParams = {
    url: `/admin/cropImage.php?section=${section}&route=${route}&page=${page}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
